
const { releaseNaverMap } = require('~/utils/naverMap')

export default {
  props: {
    idx: {
      type: Number,
      default: () => {
        return 0
      }
    },
    latitude: {
      type: Number,
      default: () => {
        return 0
      }
    },
    longitute: {
      type: Number,
      default: () => {
        return 0
      }
    }
  },
  data () {
    return {
      map: null,
      marker: null,
      innerValue: '',
      divValue: 'map',
      waitTimer: null,
      isDestroyed: false
    }
  },
  head () {
    return {
      script: [
        { src: 'https://oapi.map.naver.com/openapi/v3/maps.js?ncpKeyId=1ih8eevqgm' }
      ]
    }
  },
  beforeDestroy () {
    this.isDestroyed = true
    if (this.waitTimer) {
      clearTimeout(this.waitTimer)
      this.waitTimer = null
    }
    this.destroyMap()
  },
  methods: {
    create () {
      this.innerValue = this.divValue + this.idx
      this.$nextTick(() => {
        this.waitForNaver(0)
      })
    },
    waitForNaver (retry) {
      if (this.isDestroyed || retry > 50) { return }
      if (window.naver && window.naver.maps) {
        this.waitTimer = null
        this.initMap()
      } else {
        this.waitTimer = setTimeout(() => { this.waitForNaver(retry + 1) }, 200)
      }
    },
    initMap () {
      const container = document.getElementById(this.innerValue)
      if (this.isDestroyed || !container) { return }

      // 동일 컴포넌트에 create()가 중복 호출돼도 SDK Map을 다시 만들지 않는다.
      if (this.map) {
        this.relayout()
        return
      }
      container.innerHTML = ''

      const center = new window.naver.maps.LatLng(this.longitute, this.latitude)

      this.map = new window.naver.maps.Map(container, {
        center,
        zoom: 16,
        zoomControl: true,
        zoomControlOptions: {
          position: window.naver.maps.Position.TOP_RIGHT
        }
      })

      // eslint-disable-next-line no-new
      this.marker = new window.naver.maps.Marker({
        position: center,
        map: this.map
      })

      this.$emit('mountCallback')
    },
    relayout () {
      if (this.map) {
        const container = document.getElementById(this.innerValue)
        if (container) {
          const w = container.offsetWidth
          const h = container.offsetHeight
          if (w > 0 && h > 0) {
            this.map.setSize(new window.naver.maps.Size(w, h))
          }
        }
      }
    },
    destroyMap () {
      const marker = this.marker
      this.map = null
      this.marker = null

      releaseNaverMap({ marker })

      const container = document.getElementById(this.innerValue)
      if (container) {
        container.innerHTML = ''
      }
    }
  }
}
